import { useMutation } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { ampli } from '../../../../ampli';
import { postUsersSellTractors } from '../../../../api/user/mutations/postUsersSellTractors';

export const usePostUsersSellTractorsMutation = () => {
  const location = useLocation();

  return useMutation(postUsersSellTractors, {
    onError: (error: Error) =>
      ampli.에러발생({
        '에러 내용': error.toString(),
        '에러 종류': '판매 트랙터 등록 실패',
        '에러가 발생한 URL': location.pathname,
      }),
  });
};
